import React from 'react';
import {
    withStyles,
    ListItem,
    Button,
    Grid,
    Typography,
    ButtonBase,
    Divider,
    Snackbar,
    Tabs,
    Tab,
} from '@material-ui/core';
import Cancel from '@material-ui/icons/Cancel';
import Apis from '../../network/Apis';

import {
    withRouter,
} from "react-router-dom"

import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';
import MArrowBack from '../view/MArrowBack';
import { AreaCode } from './AreaCode'
import FIMUtils from '../../im/FIMUtils';
import './login.css'
import IMApp from '../../net/IMApp';
import AppConfig from '../../control/config';

const BG_HELLO = require("../../images/change/hello.png");
const xuankuan_icon = require("../../images/icons/xuankuan_icon@2x.png");
const xuanzhon_icon = require("../../images/icons/xuanzhon_icon@2x.png");


class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this._onItemClick = this._onItemClick.bind(this);
        this._onCancel = this._onCancel.bind(this);
        this._getPhoneCode = this._getPhoneCode.bind(this);
        this.validatePhone = this.validatePhone.bind(this);
        this.state = {
            avatar: AppData.me.Pic,
            phone: "",
            code: '',
            codeTip: '获取验证码',
            snackopened: false,
            message: '',
            tabIndex: 0,
            account: '',
            password: '',
            areaCode: '86',
            tongyi:false
        }
    }

    componentDidMount() {
        window.prevLoadingJs();
        AppUtils.YMPush('MAIN', 'LoginPage');
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _onCancel() {
        this.setState({ phone: '' });
    }

    _getPhoneCode = async () => {
        if (!this.validatePhone(this.state.phone)) {
            this.setState({ message: '请正确填写手机号码', snackopened: true });
            return;
        }

        // let result = await Apis.encryptionSendCode(this.state.phone);
        // console.log('encryptionSendCode', result);
        let result = await FIMUtils.getCode(this.state.areaCode, this.state.phone);
        if (result.ret == 0) {
            this._verifyCodeTimeAction();
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }

    //验证码登录
    codeLogin = async () => {
        // this.props.history.push('/');
        
        let Imresult = await FIMUtils.codeLogin(this.state.areaCode, this.state.phone, this.state.code);
        if (Imresult.ret != 0) {
            this.setState({ message: '验证码错误', snackopened: true });
            return;
        }
        //登录的时候，先关闭soket连接
        FIMUtils.logout();
        AppUtils.setStorageItem('uid', Imresult.user.uid)
        AppUtils.setStorageItem('fastkey', Imresult.fastkey)
        AppUtils.setStorageItem('roomIp', Imresult.server[0].svrip)
        AppUtils.setStorageItem('roomPort', Imresult.server[0].websvrport) 

        IMApp.user.uid = Imresult.user.uid;
        AppData.me.free_id = Imresult.user.fid
        AppData.me.isYk = false;
        AppData.me.fastkey = Imresult.fastkey;

        let result = await Apis.encryptionCustomerLogin(this.state.phone, Imresult.fastkey, Imresult.user.uid);

        if (result.code == 200) {
            AppData.me.token = result.data.token;
            AppData.me.customer_id = result.data.customer_id;
            AppData.me.PhoneNum = this.state.phone;
            AppUtils.setStorageItem("phone_num", AppData.me.PhoneNum);
            AppUtils.setStorageItem("user_token", AppData.me.token);
            AppUtils.setStorageItem("user_customer_id", AppData.me.customer_id);
            AppData.getUserInfo();
            AppData.reqHeatBeat();
            AppData.getMsgShield();
            AppData.getServerConfig();
            FIMUtils.connectWebSocket(Imresult);
            

            AppUtils.YMPush('MAIN', '登录成功');
            this.props.history.push('/');
        }else{
            this.setState({ message: result.msg, snackopened: true });
        }
        // let fastkey = Imresult.fastkey;
        // AppData.me.fastkey = fastkey;
        // localStorage.setItem("fastkey", AppData.me.fastkey);
        // let result = await Apis.encryptionCustomerLogin(this.state.phone, Imresult.fastkey, Imresult.user.uid);

        // if (result.code == 200) {
        //     AppData.me.token = result.data.token;
        //     AppData.me.customer_id = result.data.customer_id;
        //     AppData.me.PhoneNum = this.state.phone;
        //     localStorage.setItem("phone_num", AppData.me.PhoneNum);
        //     localStorage.setItem("user_token", AppData.me.token);
        //     localStorage.setItem("user_customer_id", AppData.me.customer_id);

        //     // FIMUtils.connectWebSocket(Imresult); 

        //     AppData.loginIn(); 
        //     AppData.login();
        //     AppData.me.isYk = false;
        //     AppUtils.YMPush('MAIN', '登录成功');
        //     this.props.history.push('/');

        // } else {
        //     this.setState({ message: result.msg, snackopened: true });
        // }
    }
    //密码登录
    passwordLogin = async () => {
        //登录的时候，先关闭soket连接
        FIMUtils.logout();
        let Imresult = await FIMUtils.passwordLogin(this.state.phone, this.state.password);
        if (Imresult.ret != 0) {
            this.setState({ message: '密码错误', snackopened: true });
            return;
        }
        let fastkey = Imresult.fastkey;
        AppData.me.fastkey = fastkey;
        localStorage.setItem("fastkey", AppData.me.fastkey);
        let result = await Apis.encryptionCustomerLogin(this.state.phone, Imresult.fastkey, Imresult.user.uid);

        AppUtils.setStorageItem('uid', Imresult.user.uid)
        AppUtils.setStorageItem('roomIp', Imresult.server[0].svrip)
        AppUtils.setStorageItem('roomPort', Imresult.server[0].websvrport)

        IMApp.user.uid = Imresult.user.uid;
        AppData.me.free_id = Imresult.user.fid
        AppData.me.isYk = false;

        if (result.code == 200) {
            AppData.me.token = result.data.token;
            AppData.me.customer_id = result.data.customer_id;
            AppData.me.PhoneNum = this.state.phone;
            AppUtils.setStorageItem("phone_num", AppData.me.PhoneNum);
            AppUtils.setStorageItem("user_token", AppData.me.token);
            AppUtils.setStorageItem("user_customer_id", AppData.me.customer_id);
            AppData.getUserInfo();
            AppData.reqHeatBeat();
            AppData.getMsgShield();
            AppData.getServerConfig();
            FIMUtils.connectWebSocket(Imresult);


            AppUtils.YMPush('MAIN', '登录成功');
            this.props.history.push('/');
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }

        // if (result.code == 200) {
        //     AppData.me.token = result.data.token;
        //     AppData.me.customer_id = result.data.customer_id;
        //     AppData.me.PhoneNum = this.state.phone;
        //     localStorage.setItem("phone_num", AppData.me.PhoneNum);
        //     localStorage.setItem("user_token", AppData.me.token);
        //     localStorage.setItem("user_customer_id", AppData.me.customer_id);

        //     // FIMUtils.connectWebSocket(Imresult);

        //     AppData.loginIn();
        //     AppData.login();
        //     AppUtils.YMPush('MAIN', '登录成功');
        //     this.props.history.push('/');

        // } else {
        //     this.setState({ message: result.msg, snackopened: true });
        // }
    }

    _onUserLogin = async () => {
        const { tabIndex } = this.state;
        let phone = '';
        if (tabIndex == 0) {

            if (!this.validateAreaCode(this.state.areaCode)) {
                this.setState({ message: '请正确填写手机区号', snackopened: true });
                return;
            }

            if (!this.validatePhone(this.state.phone)) {
                this.setState({ message: '请正确填写手机号码', snackopened: true });
                return;
            }

            if (this.state.code == '' || this.state.code.length < 4) {
                this.setState({ message: '请正确输入验证码', snackopened: true });
                return;
            }
            phone = this.state.phone;
            this.state.password = '';
            this.codeLogin()
        } else {
            const { password } = this.state;
            if (!this.validatePhone(this.state.phone)) {
                this.setState({ message: '请正确填写手机号码', snackopened: true });
                return;
            }
            if (password == '' || password.length < 6) {
                this.setState({ message: '请正确输入密码', snackopened: true });
                return;
            }
            phone = this.state.phone;
            this.state.code = '';
            this.passwordLogin()
        }


    }

    validatePhone(phone) {
        // console.log('validatePhone', phone);
        // var re = /^1[3-9]\d{9}$/;
        // return  re.test(phone);
        return phone.length > 0 && phone.length <= 11;
    }

    validateAreaCode(areaCode) {
        for (let i = 0; i < AreaCode.length; i++) {
            if (areaCode == AreaCode[i].id) {
                return true;
            }
        }
        return false;
    }



    _verifyCodeTimeAction() {
        const codeTime = 60;
        this.setState({
            codeTip: codeTime,
        });
        const now = Date.now()
        const overTimeStamp = now + codeTime * 1000 + 100/*过期时间戳（毫秒） +100 毫秒容错*/
        this.interval = setInterval(() => {
            /* 切换到后台不受影响*/
            const nowStamp = Date.now()
            if (nowStamp >= overTimeStamp) {
                /* 倒计时结束*/
                this.interval && clearInterval(this.interval);
                this.setState({
                    codeTip: '获取验证码',
                });
            } else {
                const leftTime = parseInt((overTimeStamp - nowStamp) / 1000, 10)
                this.setState({
                    codeTip: leftTime,

                });
            }
        }, 1000);
    }

    _onItemClick = (idx, enble) => {
        if (!this.state.tongyi) {
            this.setState({ message: '请同意服务协议', snackopened: true });
           return
        }
        if (enble) {
            switch (idx) {
                case 0:
                    //登录
                    this._onUserLogin();
                    break;
                default:
                    break;
            }
        }
    }

    onTabChange = (index) => {
        console.log('onTabChange', index);
        this.setState({ tabIndex: index });
    }

    _onFindPwd = () => {
        this.props.history.push('/findpwd');
    }

    onChangeAreaCode(event) {
        if (event.target.value.length > 4) {
            return;
        }
        this.setState({ areaCode: event.target.value })
    }

    onChangePhone(event) {
        if (event.target.value.length > 11) {
            return;
        }
        this.setState({ phone: event.target.value })
    }

    onChangeValid(event) {
        if (event.target.value.length > 6) {
            return;
        }
        this.setState({ code: event.target.value })
    }

    onChangePWD(event) {
        if (event.target.value.length > 12) {
            return;
        }
        this.setState({ password: event.target.value })
    }

    renderPhoneLogin = () => {
        const { classes } = this.props;
        const { phone, code, password, codeTip, tabIndex, areaCode } = this.state;
        return (
            <Grid style={{ paddingLeft: 8, paddingRight: 8 }}>
                <ListItem className={classes.listItem}>
                    <span sytle={{ fontSize: 20, color: '#007aff', fontWeight: 'bold', marginLeft: 8 }}>+</span>
                    <input
                        onChange={(event) => this.onChangeAreaCode(event)}
                        value={areaCode}
                        type='tel'
                        className={classes.textfield}
                        style={{ width: '15%', padding: 0, marginLeft: 0 }}
                        placeholder='86'
                    />
                    <input
                        onChange={(event) => this.onChangePhone(event)}
                        value={phone}
                        type='tel'
                        className={classes.textfield}
                        placeholder='请填写有效手机号'
                    />
                    <Button style={{ position: 'absolute', right: 0, minWidth: 24 }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                {
                    tabIndex == 0 && <ListItem className={classes.listItem}   >
                        <input
                            onChange={(event) => this.onChangeValid(event)}
                            value={code}
                            type='number'
                            className={classes.textfield}
                            placeholder='6位数字验证码'
                        />
                        <Typography className={classes.checkfont} onClick={() => this._getPhoneCode()}> {codeTip} </Typography>
                    </ListItem>
                }
                {
                    tabIndex == 1 && <ListItem className={classes.listItem}   >
                        <input
                            onChange={event => this.onChangePWD(event)}
                            value={password}
                            type='password'
                            className={classes.textfield}
                            placeholder='请输入密码'
                        />
                    </ListItem>
                }
                {
                    tabIndex == 0 && <ListItem className={classes.listItem1}   >
                        <Button onClick={() => this.onTabChange(1)} className={classes.buttonAccount}>
                            <Typography className={classes.buttonFont}>用密码登录</Typography>
                        </Button>
                    </ListItem>
                }
                {
                    tabIndex == 1 && <ListItem className={classes.listItem1}   >
                        <Button onClick={() => this.onTabChange(0)} className={classes.buttonYzm}>
                            <Typography className={classes.buttonFont}>用验证码登录</Typography>
                        </Button>
                        <Button onClick={() => this._onFindPwd()} className={classes.buttonFindPwd}>
                            <Typography className={classes.buttonFont}>找回密码</Typography>
                        </Button>
                    </ListItem>
                }
            </Grid>
        );
    }

    fntongyi = ()=>{
        this.setState({
            tongyi: !this.state.tongyi
        })
    }
    toxieyi = ()=>{
        let host = AppConfig.hostApi
       window.location.href=`${host}/download/serviceAgreement_b.html`
    }

    render() {
        const { classes } = this.props;
        const { snackopened, message, phone, code, password, codeTip, tabIndex, areaCode } = this.state;
        let isEnble = false;
        if (tabIndex == 0) {
            isEnble = areaCode.length > 0 && phone.length > 0 && code.length >= 4
        } else {
            isEnble = areaCode.length > 0 && phone.length > 0 && password.length >= 6
        }
        return (
            <React.Fragment>
                <div className={classes.root}>
                    <MArrowBack sytle={{ color: '#000' }} />
                    <Grid style={{ height: '10vh' }}></Grid>
                    <Grid container direction='row' justifyContent='center' style={{ width: '100vw' }}>
                        <img src={BG_HELLO} className={classes.tittle} />
                    </Grid>
                    <Grid container direction='column' className={classes.content} >
                        {this.renderPhoneLogin()}
                        <Grid container justifyContent='center' direction='column' alignItems='center' sytle={{ width: '100%' }}>
                            <Grid container justifyContent='center' direction='row' alignItems='center' style={{marginTop:30}}>
                                {
                                    !this.state.tongyi && <img onClick={()=>this.fntongyi()} src={xuankuan_icon} style={{width:15,height:15}}></img>
                                }
                                {
                                    this.state.tongyi && <img onClick={()=>this.fntongyi()} src={xuanzhon_icon} style={{width:15,height:15}}></img>
                                }
                                
                                <div onClick={()=>this.fntongyi()} style={{color:'#B2B2B2',fontSize:12,marginLeft:10}}>我已阅读并同意</div>
                                <div onClick={()=>this.toxieyi()} style={{color:'#007AFF',fontSize:12}}>《软件许可及服务协议》</div>
                            </Grid>
                            <ButtonBase className={isEnble ? classes.logoutBtn : classes.logoutBtnDisable} onClick={() => this._onItemClick(0, isEnble)}>登 录</ButtonBase>
                        </Grid>
                    </Grid>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={snackopened}
                        onClose={() => this.setState({ snackopened: false })}
                        message={message}
                        autoHideDuration={3000}>
                    </Snackbar>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100vw',
        height: '100vh',
        display: "flex",
        flexDirection: "column",
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper,
        backgroundSize: 'cover',
        animation: 'ani 10s linear infinite both alternate'
    },
    logoutBtn: {
        background: '#292929',
        borderRadius: 10,
        color: 'white',
        height: 45,
        width: "calc(100vw - 32px)",
        margin: theme.spacing(2, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    logoutBtnDisable: {
        background: '#292929',
        borderRadius: 10,
        color: 'white',
        height: 45,
        width: "calc(100vw - 32px)",
        margin: theme.spacing(2, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    tittle: {
        fontSize: 28,
        // padding: theme.spacing(0, 0, 5, 2),
        marginBottom:30,
        color: '#FFF',
        width: '180px',
        height:'90px'
    },
    checkfont: {
        fontSize: 14,
        color: '#007AFF',
        position: 'absolute',
        right: 8
    },
    textfield: {
        backgroundColor: 'transparent',
        fontSize: 15,
        height: 30,
        marginLeft: 10,
        borderRadius: 10,
        width: '60%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(1, 1, 1, 1),
    },
    content: {
        backgroundColor: '#FFF',
        minHeight: '40vh',
        width: 'calc(100vw - 16px)',
        borderRadius: 16,
    },
    listItem: {
        backgroundColor: '#F4F4F4',
        borderRadius: 10,
        height: 45,
        marginTop: 12,
        padding: theme.spacing(0, 1, 0, 1)
    },
    listItem1: {
        backgroundColor: '#FFF',
        paddingLeft: 8,
        height: 32
    },
    buttonFindPwd: {
        padding: 0,
        marginTop: 16,
        position: 'absolute',
        right: 8,
    },
    buttonYzm: {
        padding: 0,
        marginTop: 16,
        position: 'absolute',
        left: 8,
    },
    buttonAccount: {
        padding: 0,
        marginTop: 16,
        position: 'absolute',
        left: 8,
    },
    buttonFont: {
        color: '#007AFF',
        fontSize: 12
    }

}))(LoginPage));